import React, { createContext, useContext } from "react";
import { useStaticQuery, graphql } from "gatsby";

const SiteSettingsContext = createContext({ telephone: "", usps: [] });

export const useSiteSettings = () => useContext(SiteSettingsContext);

export const SiteSettingsProvider = ({ children, useSsss = false }) => {
  let data = {
    wp: {
      siteSettings: {
        siteSettings: {
          telephone: "",
          ssssTelephone: "",
          usps: [],
          ssssUsps: [],
        },
      },
    },
  };

  if (!process.env.STORYBOOK) {
    data = useStaticQuery(graphql`
      query SiteSettingsProviderQuery {
        wp {
          siteSettings {
            siteSettings {
              telephone
              ssssTelephone
              usps {
                icon
                text
                link {
                  url
                  target
                  title
                }
              }
              ssssUsps {
                icon
                text
                link {
                  url
                  target
                  title
                }
              }
            }
          }
        }
      }
    `);
  }

  const settings = data.wp.siteSettings.siteSettings;

  const value = {
    telephone:
      useSsss && settings.ssssTelephone
        ? settings.ssssTelephone
        : settings.telephone,
    usps:
      useSsss && settings.ssssUsps
        ? settings.ssssUsps
        : settings.usps,
  };

  return (
    <SiteSettingsContext.Provider value={value}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export default SiteSettingsProvider;
